import type {Schemas} from 'domainTypes/dto';
import orderBy from 'lodash/orderBy';
import type {AgentName} from '../types';

export const mapNameVariantsDto = (
  dto: Schemas.AgentNameDto[],
): AgentName[] => {
  // If any description is set, give all empty string as value.
  const anyDescription = (dto ?? []).some(a => a.description);

  return orderBy(dto, ['nameOrder'], ['asc']).map(
    ({nameOrder: _, description, ...rest}) => ({
      ...rest,
      description: description
        ? description.trim()
        : anyDescription
          ? ''
          : undefined,
    }),
  );
};

export const mapToNameVariantsDto = (
  nameVariants: AgentName[],
): Schemas.AgentNameDto[] =>
  nameVariants.map(({description, ...rest}, idx) => ({
    ...rest,
    description: description ? description.trim() : undefined,
    nameOrder: idx,
  }));
